<template>
  <v-container fluid>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="data.data"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="footerProps"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item="{ item }">
         <tr> 
          <td>{{item.locNo}}</td>
          <td>{{item.code}}</td>
          <td>{{item.ownerNo}}</td>
          <td>{{item.name}}</td>
          <td>{{item.countryNum}}</td>
         </tr> 
        </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>

<script>
import DataService from '../services/data'

export default {
  data() {
    return {
      loading: false,
      pagination: { rowsPerPage: 10 },
      footerProps: {
        showFirstLastPage: true,
        firstIcon: 'mdi-chevron-double-left',
        lastIcon: 'mdi-chevron-double-right',
        prevIcon: 'mdi-chevron-left',
        nextIcon: 'mdi-chevron-right',
        itemsPerPageOptions: [10,20,40]
      },
      totalItems: 0,
      headers: [
        { text: 'LocNo', value: 'locNo', sortable: false },
        { text: 'Code', value: 'code', sortable: false },
        { text: 'Owner', value: 'ownerNo', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Country', value: 'countryNum', sortable: false }
      ],
      data: []
    }
  },

  watch: {
    pagination: {
      handler: 'paginate',
      immediate: false
    }
  },

  created() {
    this.dataService = new DataService(this.profile, this.$store.state.tokens)
  },

  methods: {
    getItemPerPage(rows) {
      this.pagination.rowsPerPage = rows;
      this.paginate();
    },
    paginate() {
      this.loading = true
      this.dataService.getLocations(this.pagination.page, this.pagination.rowsPerPage).then(result => {
        this.totalItems = result.data.totalElements
        this.data = result.data
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Locations.vue?23e16c39